import { WeatherObservationData } from "../../entities";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../utils/ProtocolTypeUtils";
import OldRecordsParser from './OldRecordsParser';
import StringToNumberPropTransformer from './StringToNumberPropTransformer';
const ENVIRONMENT_DATA_TAG = 'EnvData';
export default class WeatherObservationParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.WEATHER_OBSERVATION, FIXED_PROTOCOL_CONTENT_TYPE_IDS.WEATHER_OBSERVATION, ENVIRONMENT_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            apress: new StringToNumberPropTransformer('apress'),
            atemp: new StringToNumberPropTransformer('atemp'),
            wtemp: new StringToNumberPropTransformer('wtemp'),
            relhum: new StringToNumberPropTransformer('relhum'),
            weather: 'weather',
            vis: 'vis',
            twind: 'twind',
            swell: 'swell',
            seastate: 'seastate',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new WeatherObservationData(props.apress, props.atemp, props.wtemp, props.relhum, props.weather, props.vis, props.twind, props.seastate, props.swell, props.freeText);
    }
}
//# sourceMappingURL=WeatherObservationParser.js.map